import "./RemoveTask.scss";

function RemoveTask({ cancelRemoveTask, removeTask }) {
  return (
    <div className="remove-task-content">
      <div className="modal-title">
        <div>Remove Task</div>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to delete this task?</p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveTask}>
          Cancel
        </button>
        <button className="modal-button delete" onClick={removeTask}>
          Remove
        </button>
      </div>
    </div>
  );
}

export default RemoveTask;
